<div class="admin-support-dashboard">
  <div class="page-body">
    <ng-container *ngIf="!store.activeCaseId()">
      <app-stat-cards
        [counts]="store.counts()"
        [tab]="store.tab()"
        [statFilter]="store.statFilter()"
        (cardClicked)="onCardClicked($event)">
      </app-stat-cards>

      <app-case-table
        [tab]="store.tab()"
        [cases]="store.cases()"
        [member]="store.member()"
        [page]="store.page()"
        [pageSize]="store.pageSize()"
        [totalCount]="store.totalCount()"
        (tabChanged)="onTabChanged($event)"
        (memberChanged)="onMemberChanged($event)"
        (rowClicked)="onRowClicked($event)"
        (pageChanged)="onPageChanged($event)">
      </app-case-table>
    </ng-container>

    <app-case-thread
      *ngIf="store.activeCaseId()"
      [thread]="store.thread()"
      [sending]="store.sendingReply()"
      [closing]="store.closingCase()"
      (back)="onBack()"
      (reply)="onReply($event)"
      (closeCase)="onCloseCase()">
    </app-case-thread>
  </div>
</div>
